import products from '@/store/modules/catalog/products'
import taxonomy from '@/store/modules/catalog/taxonomy'

const modules = {
  products,
  taxonomy
}

export default {
  namespaced: true,
  modules
}
